import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { clearRecentSearches } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/recentSearches.source";
import { useSearchBarContext } from "@/components/Search/SearchBar/context/searchBar.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const ClearButton = ({ className }: Props) => {
    const { t } = useGranite();
    const { autocompleteActions } = useSearchBarContext();

    const handleOnClearAllRecentSearchItem = () => {
        clearRecentSearches();
        autocompleteActions?.refresh();
    };

    return (
        <Button
            type={"button"}
            color={"link"}
            className={cn("tw:py-2 tw:px-0 tw:text-primary", className)}
            onClick={handleOnClearAllRecentSearchItem}
        >
            {t("searchBox.panel.recentSearches.footer.button.clearAll")}
        </Button>
    );
};
